module.exports = __webpack_public_path__ + "static/forecast/weather/nightlightsnow-bbb3c8dda538975e0c8703cf0b202c0e.svg";